<script>
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onBeforeUnmount, provide } from "vue";
import { Primitive } from "@maas/vue-primitive";
import { MagicAccordionInstanceId } from "../symbols";
import { useAccordionState } from "../composables/private/useAccordionState";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicAccordionProvider",
  props: {
    id: { type: null, required: true },
    asChild: { type: Boolean, required: false },
    options: { type: Object, required: false }
  },
  setup(__props) {
    const { deleteState, initializeState } = useAccordionState(__props.id);
    initializeState(__props.options);
    onBeforeUnmount(() => {
      deleteState();
    });
    provide(MagicAccordionInstanceId, __props.id);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Primitive), {
        "data-id": _ctx.id,
        "as-child": _ctx.asChild,
        class: "magic-accordion-provider"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["data-id", "as-child"]);
    };
  }
});
</script>
